"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reduxObservable = require("redux-observable");

var _epics = _interopRequireWildcard(require("settings-content-modals/EmailCreationModal/PortalSettings/epics"));

var _default = (0, _reduxObservable.combineEpics)(_epics.default, _epics.stageAndSavePortalSetting);

exports.default = _default;
module.exports = exports.default;